module.exports = __webpack_public_path__ + "img/re_successLeft.671313a9.png";